import { FC, useEffect, useRef } from "react";
import { buildASOPath, buildClockworkWebPath } from "lib/resource-finder";
import { useGetMemberPermissionsQuery } from "types/generated/operations";

const ClaimsRedirect: FC = () => {
  const { data, loading, error } = useGetMemberPermissionsQuery();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (loading || didRedirect.current) return;
    if (!data && !error) return;

    didRedirect.current = true;
    const cdmsId =
      data?.authenticatedMember?.company?.cdmsCanonicalCompanyId ?? "";
    const url = cdmsId
      ? buildASOPath(`/company/${cdmsId}/peo-workers-comp/claims/drafts`)
      : buildClockworkWebPath("/");
    window.location.assign(url);
  }, [loading, data, error]);

  return null;
};

export default ClaimsRedirect;
